<template>
    <div>
        <div class="content-header">
            <PageTitleComponent :title="'EVENTO: ' + (evento ? evento.name : '')"></PageTitleComponent>
        </div>
        
        <section class="content" id="container">
            <div class="container-fluid" v-if="evento && sesion">
                <template v-if="evento.place_obj && evento.place_obj.show_all_seats">
                    <ProcesoCompraPlanoGeneral :evento="evento" :sesion="sesion"></ProcesoCompraPlanoGeneral>
                </template>
                <template v-else>
                    <ProcesoCompraNormal v-if="renderizar" :evento="evento" :sesion="sesion" @getEvento="getEvento"></ProcesoCompraNormal>
                </template>                
            </div>
        </section>        
    </div>
</template>

<script>
import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
import ProcesoCompraNormal from '@/components/backend/eventos/venta/ProcesoCompraNormal';
import ProcesoCompraPlanoGeneral from '@/components/backend/eventos/venta/ProcesoCompraPlanoGeneral';

export default {
    props: ['evento_id', 'sesion_id'],
    data() {
        return {
            evento: null,
            sesion: null,
            loading: false,
            renderizar: true,
        }
    },
    created() {
        this.getEvento();
        this.getSesion();
        localStorage.removeItem('zona_id');
    },
    methods: {
        getSesion : function() {
            this.loading = true;

            const params = {
                filters : {},
                evento_id: this.evento_id,
                sesion_id: this.sesion_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.show'), params).then(res => {
                this.sesion = res.data.data;
            }).finally(() => this.loading = false);
        },
        getEvento() {
            this.loading = true;
            const data = {
                evento_id: this.$route.params.evento_id,
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.venta-taquilla'), data).then(res => {
                this.recargar()
                this.evento = res.data.data;
            }).finally(() => this.loading = false);
        },
        recargar(){
            return new Promise(() => {
                this.renderizar = false;
                this.$nextTick(() => {
                    this.renderizar = true;
                })
            })
        }
    },
    components: {
        PageTitleComponent, ProcesoCompraNormal, ProcesoCompraPlanoGeneral
    }
}
</script>
